document.addEventListener('DOMContentLoaded', () => {
  // Debug configuration - set to true to enable debug logging
  const DEBUG_MODE = false;
  
  // Debug logger
  function debugLog(message, data = null) {
    if (DEBUG_MODE) {
      console.log(`[WKND Recharge Debug] ${message}`, data || '');
    }
  }
  
  // Extract currency symbol from price string
  function extractCurrencySymbol(priceText) {
    const match = priceText.match(/^([^\d\s.,]+)|([^\d\s.,]+)$/);
    return match ? (match[1] || match[2]).trim() : '$';
  }
  
  // Extract numeric value from price string
  function extractNumericPrice(priceText) {
    return parseFloat(priceText.replace(/[^\d.,]/g, '').replace(',', ''));
  }

  // Cache DOM elements
  const customWidget = document.querySelector('.wknd_recharge-widget');
  const customOneTimeOption = document.querySelector('.wknd_recharge-option[data-option="onetime"]');
  const customSubscribeOption = document.querySelector('.wknd_recharge-option[data-option="subscribe"]');
  const preloader = document.querySelector('.wknd_recharge-preloader');
  const customDropdown = document.querySelector('#wknd_delivery_frequency');
  const subscriptionOptionsContainer = document.querySelector('.wknd_recharge-subscription-options');
  const deliveryPeriodSpan = document.querySelector('.wknd_recharge-delivery-period');
  
  debugLog('DOM elements found:', {
    customWidget: !!customWidget,
    customOneTimeOption: !!customOneTimeOption,
    customSubscribeOption: !!customSubscribeOption,
    preloader: !!preloader,
    customDropdown: !!customDropdown,
    subscriptionOptionsContainer: !!subscriptionOptionsContainer,
    deliveryPeriodSpan: !!deliveryPeriodSpan
  });

  if (!customWidget || !customOneTimeOption || !customSubscribeOption || !preloader) {
    console.error('Custom recharge widget elements not found');
    return;
  }

  // Find Recharge inputs and dropdown
  function findRechargeElements() {
    return {
      onetime: document.querySelector('.rc-radio__input[value="onetime"]'),
      subscribe: document.querySelector('.rc-radio__input[value="subsave"]'),
      dropdown: document.querySelector('.rc-selling-plans__dropdown')
    };
  }

  // Extract delivery period from option text (keep original format)
  function extractDeliveryPeriod(optionText) {
    debugLog('Extracting delivery period from:', optionText);
    
    // Extract the frequency part (e.g., "1 month", "6 week", "2 month")
    const match = optionText.match(/(\d+\s+(?:week|month|day)s?)/i);
    if (match) {
      const period = match[1];
      debugLog('Extracted period:', period);
      return period;
    }
    
    debugLog('No period found, using default');
    return '1 month';
  }

  // Populate custom dropdown with options from Recharge dropdown
  function populateCustomDropdown() {
    const elements = findRechargeElements();
    
    if (!elements.dropdown || !customDropdown) {
      debugLog('Dropdown elements not found for population');
      return false;
    }
    
    // Clear existing options
    customDropdown.innerHTML = '';
    
    // Get options from Recharge dropdown
    const rechargeOptions = elements.dropdown.querySelectorAll('option');
    debugLog('Found Recharge dropdown options:', rechargeOptions.length);
    
    rechargeOptions.forEach((option, index) => {
      const customOption = document.createElement('option');
      customOption.value = option.value;
      customOption.textContent = option.textContent;
      customOption.dataset.period = extractDeliveryPeriod(option.textContent);
      
      // Select the first option by default
      if (index === 0) {
        customOption.selected = true;
      }
      
      customDropdown.appendChild(customOption);
      
      debugLog(`Added option ${index}:`, {
        value: option.value,
        text: option.textContent,
        period: customOption.dataset.period
      });
    });
    
    return true;
  }

  // Update delivery period text based on selected option
  function updateDeliveryPeriod() {
    if (!customDropdown || !deliveryPeriodSpan) {
      debugLog('Elements not found for updating delivery period');
      return;
    }
    
    const selectedOption = customDropdown.options[customDropdown.selectedIndex];
    if (selectedOption && selectedOption.dataset.period) {
      deliveryPeriodSpan.textContent = selectedOption.dataset.period;
      debugLog('Updated delivery period to:', selectedOption.dataset.period);
    }
  }

  // Update custom prices from Recharge widget v1
  // function updateCustomPrices() {
  //   const oneTimePriceEl = document.querySelector('.rc_widget__price--onetime');
  //   const subscribePriceEl = document.querySelector('.rc_widget__price--subsave');
    
  //   const wkndOneTimePriceEl = document.querySelector('.wknd_recharge-option[data-option="onetime"] .wknd_price');
  //   const wkndSubscribeSalePriceEl = document.querySelector('.wknd_recharge-option[data-option="subscribe"] .wknd_price--sale');
  //   const wkndSubscribeComparePriceEl = document.querySelector('.wknd_recharge-option[data-option="subscribe"] .wknd_price--compare');
  //   const wkndSubscribeDiscountEl = document.querySelector('.wknd_recharge-option[data-option="subscribe"] .wknd_recharge-option-badge');
    
  //   debugLog('Updating prices from Recharge widget');
    
  //   // Get original product price from Liquid variable
  //   const originalProductPrice = document.querySelector('.wknd_price--compare').textContent.trim();
    
  //   // Update one-time purchase price
  //   if (oneTimePriceEl && wkndOneTimePriceEl) {
  //     wkndOneTimePriceEl.textContent = oneTimePriceEl.textContent.trim();
  //     debugLog('Updated one-time price:', oneTimePriceEl.textContent.trim());
  //   }
    
  //   // Update subscription prices
  //   if (subscribePriceEl && wkndSubscribeSalePriceEl && wkndSubscribeComparePriceEl) {
  //     const subscribePriceText = subscribePriceEl.textContent.trim();
  //     const salePrice = parseFloat(subscribePriceText.replace('$', ''));
  //     const originalPrice = parseFloat(originalProductPrice.replace('$', ''));
      
  //     // Update sale and compare prices
  //     wkndSubscribeSalePriceEl.textContent = subscribePriceText;
  //     wkndSubscribeComparePriceEl.textContent = originalProductPrice;
      
  //     // Update discount badge
  //     if (wkndSubscribeDiscountEl) {
  //       const discountPercentage = Math.round((1 - salePrice / originalPrice) * 100);
  //       wkndSubscribeDiscountEl.textContent = `Save ${discountPercentage}%`;
  //       debugLog('Updated discount percentage:', `${discountPercentage}%`);
  //     }
      
  //     debugLog('Updated subscription prices:', {
  //       sale: subscribePriceText,
  //       compare: originalProductPrice
  //     });
  //   }
  // }

  // Update custom prices from Recharge widget v2
  function updateCustomPrices() {
    console.log('new code loaded');
    const oneTimePriceEl = document.querySelector('.rc_widget__price--onetime');
    const subscribePriceEl = document.querySelector('.rc_widget__price--subsave');
    
    const wkndOneTimePriceEl = document.querySelector('.wknd_recharge-option[data-option="onetime"] .wknd_price');
    const wkndSubscribeSalePriceEl = document.querySelector('.wknd_recharge-option[data-option="subscribe"] .wknd_price--sale');
    const wkndSubscribeComparePriceEl = document.querySelector('.wknd_recharge-option[data-option="subscribe"] .wknd_price--compare');
    const wkndSubscribeDiscountEl = document.querySelector('.wknd_recharge-option[data-option="subscribe"] .wknd_recharge-option-badge');
    
    debugLog('Updating prices from Recharge widget');
    
    // Update one-time purchase price
    if (oneTimePriceEl && wkndOneTimePriceEl) {
      wkndOneTimePriceEl.textContent = oneTimePriceEl.textContent.trim();
      debugLog('Updated one-time price:', oneTimePriceEl.textContent.trim());
    }
    
    // Update subscription prices
    if (subscribePriceEl && wkndSubscribeSalePriceEl && wkndSubscribeComparePriceEl) {
      const subscribePriceText = subscribePriceEl.textContent.trim();
      const currencySymbol = extractCurrencySymbol(subscribePriceText);
      
      // Get numeric values for calculation
      const salePrice = extractNumericPrice(subscribePriceText);
      
      // Get original price from the custom widget's compare price element
      // const originalProductPrice = wkndSubscribeComparePriceEl.textContent.trim();
      // const originalPrice = extractNumericPrice(originalProductPrice);

      // Get original price from Recharge one-time price (correct currency)
      const originalProductPrice = oneTimePriceEl ? oneTimePriceEl.textContent.trim() : wkndSubscribeComparePriceEl.textContent.trim();
      const originalPrice = extractNumericPrice(originalProductPrice);
      
      // Update compare price with correct currency
      wkndSubscribeComparePriceEl.textContent = originalProductPrice;
      
      // Update sale price
      wkndSubscribeSalePriceEl.textContent = subscribePriceText;
      
      // Update discount badge
      if (wkndSubscribeDiscountEl && originalPrice > 0) {
        const discountPercentage = Math.round((1 - salePrice / originalPrice) * 100);
        wkndSubscribeDiscountEl.textContent = `Save ${discountPercentage}%`;
        debugLog('Updated discount percentage:', `${discountPercentage}%`);
      }
      
      debugLog('Updated subscription prices:', {
        sale: subscribePriceText,
        compare: originalProductPrice,
        currency: currencySymbol
      });
    }
  }

  // Handle custom option selection
  function handleCustomOptionClick(optionType) {
    const elements = findRechargeElements();
    
    debugLog('Custom option clicked:', optionType);
    
    if (optionType === 'onetime') {
      if (elements.onetime) {
        elements.onetime.click();
        debugLog('Clicked Recharge onetime input');
      }
      customOneTimeOption.classList.add('wknd_recharge-option--selected');
      customSubscribeOption.classList.remove('wknd_recharge-option--selected');
      
      // Hide subscription options
      if (subscriptionOptionsContainer) {
        subscriptionOptionsContainer.style.display = 'none';
      }
      
    } else if (optionType === 'subscribe') {
      if (elements.subscribe) {
        elements.subscribe.click();
        debugLog('Clicked Recharge subscribe input');
      }
      customSubscribeOption.classList.add('wknd_recharge-option--selected');
      customOneTimeOption.classList.remove('wknd_recharge-option--selected');
      
      // Show subscription options
      if (subscriptionOptionsContainer) {
        subscriptionOptionsContainer.style.display = 'block';
      }
      
      // Update delivery period
      updateDeliveryPeriod();
    }
    
    updateCustomPrices();
  }

  // Handle custom dropdown change
  function handleCustomDropdownChange() {
    const elements = findRechargeElements();
    
    if (!elements.dropdown || !customDropdown) {
      debugLog('Dropdown elements not found for change handler');
      return;
    }
    
    const selectedValue = customDropdown.value;
    debugLog('Custom dropdown changed to:', selectedValue);
    
    // Update the Recharge dropdown
    elements.dropdown.value = selectedValue;
    
    // Trigger change event on Recharge dropdown
    const changeEvent = new Event('change', { bubbles: true });
    elements.dropdown.dispatchEvent(changeEvent);
    
    // Update delivery period text
    updateDeliveryPeriod();
    
    // Update prices (in case they change based on frequency)
    setTimeout(updateCustomPrices, 100);
  }

  // Event listeners
  customOneTimeOption.addEventListener('click', () => handleCustomOptionClick('onetime'));
  customSubscribeOption.addEventListener('click', () => handleCustomOptionClick('subscribe'));
  
  if (customDropdown) {
    customDropdown.addEventListener('change', handleCustomDropdownChange);
  }

  // Check if Recharge widget is loaded and initialize
  function checkRechargeWidget() {
    const rechargeWidget = document.querySelector('.rc-widget');
    const elements = findRechargeElements();
    
    debugLog('Checking Recharge widget...', {
      widget: !!rechargeWidget,
      onetime: !!elements.onetime,
      subscribe: !!elements.subscribe,
      dropdown: !!elements.dropdown
    });
    
    if (rechargeWidget && elements.onetime && elements.dropdown) {
      debugLog('Recharge widget found! Initializing...');
      
      // Remove preloader
      preloader.style.display = 'none';
      customWidget.classList.remove('wknd_recharge-widget--loading');
      
      // Populate custom dropdown
      if (populateCustomDropdown()) {
        debugLog('Custom dropdown populated successfully');
      }
      
      // Default to one-time option
      customOneTimeOption.click();
      
      // Show the widget content
      const widgetContent = document.querySelector('.wknd_recharge_widget_content');
      if (widgetContent) {
        widgetContent.style.opacity = '1';
        debugLog('Widget content shown');
      }
      
    } else {
      // Continue checking
      setTimeout(checkRechargeWidget, 100);
    }
  }

  // Start checking for Recharge widget
  debugLog('Starting Recharge widget detection...');
  checkRechargeWidget();
});